// extracted by mini-css-extract-plugin
module.exports = {"title":"_2MNte","grid":"_1gpjt","one-column-mobile":"_2Jm25","oneColumnMobile":"_2Jm25","mobile":"NJO2Q","minimal":"urvrq"};